import BaseApiAction from '@Actions/base-api-action';
export default class UnlinkUserFromTeam extends BaseApiAction {
  runAction() {
    super.invokeCloudFunction({
      name: 'teams-unlinkUserFromTeam',
      payload: {
        user_id: this._payload.user_id,
        team_id: this._payload.team_id
      },
    });
  }
  onSuccess(data) {
    super.onSuccess(...arguments);
  }
}
